import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import TradingRoutine from "@/pages/TradingRoutine";
import Journal from "@/pages/Journal";
import EconomicCalendar from "@/pages/EconomicCalendar";
import News from "@/pages/News";
import Faith from "@/pages/Faith";
import Tasks from "@/pages/Tasks";
import Reminders from "@/pages/Reminders";

function Protected({ children }) {
    return (
        <ProtectedRoute>
            <Layout>{children}</Layout>
        </ProtectedRoute>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#18181B",
                            border: "1px solid rgba(255,255,255,0.08)",
                            color: "#FAFAF9",
                        },
                    }}
                />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/" element={<Protected><Dashboard /></Protected>} />
                    <Route path="/trading" element={<Protected><TradingRoutine /></Protected>} />
                    <Route path="/journal" element={<Protected><Journal /></Protected>} />
                    <Route path="/calendar" element={<Protected><EconomicCalendar /></Protected>} />
                    <Route path="/news" element={<Protected><News /></Protected>} />
                    <Route path="/faith" element={<Protected><Faith /></Protected>} />
                    <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
                    <Route path="/reminders" element={<Protected><Reminders /></Protected>} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
